
import './App.css';
import Header from './components/Header';
import Home from './components/Home';
import News from './components/News';
import Marketing from './components/Marketing';
import Programme from './components/Programme';
import About from './components/About';
import Contact from './components/Contact';
import Team from './components/Team';
import PriceList from './components/PriceList';
import Audience from './components/Audience';
import AdsJingles from './components/AdsJingles';
import AdsCongratulations from './components/AdsCongratulations';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";
import Article from './components/Article';
import ArticlesCategory from './components/ArticlesCategory';
import Shows from './components/Shows';

function App() {
  return (
    <div className="App">
      <Router>
        <div>
          <Header />
          {/* A <Switch> looks through its children <Route>s and
            renders the first one that matches the current URL. */}
          <Switch>
            <Route
              path="/vijesti"
              render={({ match: { url } }) => (
                <>
                  <Route path={`${url}/`} component={News} exact />
                  <Route path={`${url}/:category`} component={ArticlesCategory} />
                </>
              )}
            />
            <Route path="/marketing">
              <Marketing />
            </Route>
            <Route path="/cjenik">
              <PriceList />
            </Route>
            <Route path="/slusanost">
              <Audience />
            </Route>
            <Route path="/reklame-jinglovi">
              <AdsJingles />
            </Route>
            <Route path="/oglasi-cestitke">
              <AdsCongratulations />
            </Route>
            <Route path="/program">
              <Programme />
            </Route>
            <Route path="/emisije">
              <Shows />
            </Route>
            <Route path="/o-nama">
              <About />
            </Route>
            <Route path="/kontakt">
              <Contact />
            </Route>
            <Route path="/tim">
              <Team />
            </Route>
            <Route path="/vijest/:slug" children={<Article />} />
            <Route path="/">
              <Home />
            </Route>
          </Switch>
        </div>
      </Router>
    </div>
  );
}

export default App;
